class EmmMediaMentions extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sliderEl = null;
    this.swiperPollId = null;
    this.resizeObserver = null;
    this.hasUserInteracted = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.sliderEl = this.querySelector('.emm__swiper');
    if (!this.sliderEl) return;

    this.wrapEl = this.querySelector('.emm__swiper-wrap') || this.sliderEl;
    this.dateEl = this.querySelector('.emm__date');

    this.waitForSwiper();
  }

  disconnectedCallback() {
    if (this.swiperPollId) {
      clearInterval(this.swiperPollId);
      this.swiperPollId = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    this.destroySwiper();
  }

  waitForSwiper() {
    if (typeof window.Swiper === 'function') {
      this.initSwiper();
      return;
    }

    let attempts = 0;
    this.swiperPollId = setInterval(() => {
      attempts += 1;
      if (typeof window.Swiper === 'function') {
        clearInterval(this.swiperPollId);
        this.swiperPollId = null;
        this.initSwiper();
      } else if (attempts >= 100) {
        clearInterval(this.swiperPollId);
        this.swiperPollId = null;
      }
    }, 50);
  }

  initSwiper() {
    if (this.swiper || !this.sliderEl) return;

    this.swiper = new window.Swiper(this.sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 400,
      allowTouchMove: false,
      a11y: { enabled: true }
    });

    this.wrapEl.addEventListener('click', e => {
      if (!this.swiper) return;

      if (e.target.closest('.emm__arrow--prev')) {
        this.hasUserInteracted = true;
        this.swiper.slidePrev();
      }

      if (e.target.closest('.emm__arrow--next')) {
        this.hasUserInteracted = true;
        this.swiper.slideNext();
      }
    });

    this.updateDate();

    const headingEl = this.querySelector('.emm__heading');

    this.swiper.on('slideChange', () => {
      this.updateDate();

      if (
        !this.hasUserInteracted ||
        !headingEl ||
        typeof calculateScrollPercentage !== 'function'
      ) {
        return;
      }

      calculateScrollPercentage(this.swiper, headingEl);
    });

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.swiper) this.swiper.update();
      });
      this.resizeObserver.observe(this);
    }
  }

  updateDate() {
    if (!this.dateEl || !this.swiper) return;
    const slide = this.swiper.slides[this.swiper.activeIndex];
    this.dateEl.textContent = slide ? slide.dataset.date || '' : '';
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('emm-media-mentions')) {
  customElements.define('emm-media-mentions', EmmMediaMentions);
}
